import { useState } from "react";

const EmailSender = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [succeeded, setSucceeded] = useState(false);
  const [error, setError] = useState(null);

  // The reply-to email address that will be used for all emails
  const replyToEmail = "info@xpandelevate.com";

  const sendEmail = async (
    formData,
    emailSubject,
    recipientEmail,
    customTemplate = null
  ) => {
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await fetch(
        "https://email-nodejs-fawn.vercel.app/api/send-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            emailConfig: {
              // host: "mail5015.site4now.net",
              // port: 465,
              // user: "salam@playpro.pk",
              // pass: "!@#123Pass",
              // from: "PlayPro <salam@playpro.pk>",

              host: "xpandelevate.com",
              port: 465,
              user: "info@xpandelevate.com",
              pass: "!@#123Pass@",
              from: "Xpand Elevate <info@xpandelevate.com>",

              // host: "mail.weboget.com",
              // port: 465,
              // user: "xpandelevate@weboget.com",
              // pass: "$UjmnHbQ~3xS]Yhd",
              // from: "Xpand Elevate <xpandelevate@weboget.com>",
            },
            emailData: {
              to: recipientEmail,
              from: {
                name: "Xpand Elevate",
                email: "info@xpandelevate.com",
              },
              sender: {
                name: "Xpand Elevate",
                email: "info@xpandelevate.com",
              },
              replyTo: replyToEmail,
              headers: {
                "Reply-To": replyToEmail,
                "Return-Path": replyToEmail,
                From: "Xpand Elevate <info@xpandelevate.com>",
              },
              subject: emailSubject,
              text: generateTextContent(formData, replyToEmail),
              html:
                customTemplate || generateHtmlContent(formData, replyToEmail),
            },
          }),
        }
      );

      if (response.ok) {
        setSucceeded(true);
        return true;
      } else {
        const errorData = await response.json();
        setError(errorData.message || "Failed to submit. Please try again.");
        return false;
      }
    } catch (err) {
      setError("Network error. Please try again later.");
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  const generateTextContent = (formData, replyEmail) => {
    let content = Object.entries(formData)
      .map(([key, value]) => `${key}: ${value}`)
      .join("\n");

    // Add a footer with the reply information
    content += `\n\n---\nPlease reply to: ${replyEmail}`;
    return content;
  };

  const generateHtmlContent = (formData, replyEmail) => {
    return `
      <h2>New Form Submission</h2>
      ${Object.entries(formData)
        .map(([key, value]) => `<p><strong>${key}:</strong> ${value}</p>`)
        .join("")}
      <hr />
      <p style="font-size: 12px; color: #666;">If you'd like to respond to this email, please reply to: <a href="mailto:${replyEmail}">${replyEmail}</a></p>
    `;
  };

  return {
    isSubmitting,
    succeeded,
    error,
    sendEmail,
    setSucceeded, // Expose this to reset success state if needed
    setError, // Expose this to reset error state if needed
  };
};

export default EmailSender;
